export default "<p>\r\n  switch-network works!\r\n</p>\r\n";